import axios from 'axios'
import { config } from '../../config/config'
// 创建axios实例
const reqConfig = config
const service = axios.create({
  baseURL: reqConfig.baseAPI,
  timeout: 30 * 1000,
})
service.defaults.transformRequest = [
  function (data) {
    let ret = ''
    let count = 0
    for (const it in data) {
      count++
      ret +=
        encodeURIComponent(it) +
        '=' +
        encodeURIComponent(data[it]) +
        (count < Object.keys(data).length ? '&' : '')
    }
    return ret
  },
]
// 请求拦截，增加token
service.interceptors.request.use(config => {
  if (reqConfig && reqConfig.token) {
    const visitor = sessionStorage.getItem('visitor')
    if (visitor) {
      config.headers.visitor = visitor
    }
    // config.headers['X-FORWARD-ID-TOKEN'] = reqConfig.token
    config.headers.Authorization = 'Bearer ' + reqConfig.token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
})

// 应答拦截，判断返回结果是否正确
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    return Promise.reject(new Error(error).message)
  }
)

export default service
